import {combineReducers} from "redux";
import creerCommandeReducer from "./creerCommande";
import fetchCommandeReducer from "./fetchCommande";
import payerCommandeReducer from "./payerCommande";

export default combineReducers({
    creerCommande : creerCommandeReducer,
    fetchCommande : fetchCommandeReducer,
    payerCommande : payerCommandeReducer,
});